import React from 'react';
import Speaker from "../../components/speaker/Speaker";

import "./SpeakerPane.css";

import JohnHarmanPortrait from "../../images/john-harman.jpg";
import ScottMaderPortrait from "../../images/scott-mader.jpg";
import ScottStirn from "../../images/scott-stirn.png";
import MoJain from "../../images/mo-jain.jpg";
import DerrickMiyao from "../../images/derrick-miyao.jpg";
import YongDongWang from "../../images/yongdong-wang.png";

export default function SpeakerPane(props) {

    const speakers = [
        {
            name: "John Harman",
            field: "",
            company: "",
            degrees: [
            ],
            portrait: JohnHarmanPortrait,
            bio: <span>
                    John spent his first 20 years evaluating and implementing new approaches to small molecule
                analysis and purification, compound management, HTS and lab informatics solutions.<br/><br/>After another 8
                years designing, managing, and implementing automation and software as part of digital transformation,
                John now is a consultant bringing analytical, automation, and knowledge management solutions to
                multiple companies, including 3 fully automated DMTA laboratory designs.
                <br/><br/>
                In his spare time John is working to build and deliver a not-for-profit product to market which
                will replace all other lab informatics products.
            </span>
        },
        {
            name: "Scott Mader",
            field: "",
            company: "",
            degrees: [
            ],
            portrait: ScottMaderPortrait,
            bio: <span>
                    Over his 35-year career, Scott Mader has launched transformative clinical innovation in
                Pharmaceutical, In Vitro Diagnostics, and Medical Device categories.<br/><br/>
                In the 90’s, Mader spearheaded the launch of Glucophage (Metformin), a transformative
                and foundational treatment for type 2 diabetes.  In the early 2000’s, Mader drove the
                meteoric growth of Point of Care BNP biomarker testing into acute care guidelines,
                resulting in a $1.6B acquisition of San Diego’s Biosite Diagnostics in 2007.
                <br/><br/>His consulting firm, CLINDEVOR 360, successfully commercialized prototypic innovation
                into explosive nascent markets including lateral flow immunoassays,  GLP-1 agonists,
                TZD’s, and the emergence of high sensitivity Troponin POC testing.  Today, Mader is
                setting new infection control standards by automating aseptic technique as Founder
                and Chief Executive Officer of AseptiScope, a Medical Technology Start-Up in San Diego, California.
            </span>
        },
        {
            name: "Scott Stirn",
            field: "",
            company: "",
            degrees: [
            ],
            portrait: ScottStirn,
            bio: <span>
                    Scott Stirn, MS, MSJ, serves as the Director of Product Development, Early Stage, at Neurocrine Biosciences Inc.
                    He's responsible for guiding programs from research through development, specifically leading the
                    Preformulation, Product Development, and Materials Science functions.
                    Scott has been instrumental in strengthening the company's intellectual property,
                    with his contributions as an inventor on over 75 United States and International patents.
                    He also takes on the role of Program Lead for assets as they advance from discovery into early clinical studies.
                    <br/><br/>
                    Drawing on over 18 years of experience in drug development across both small and large
                    pharmaceutical settings, Scott is passionate about cultivating dynamic teams, encouraging
                    continuous learning, and mentoring scientists.
                    <br/><br/>
                    He holds degrees from the University of Arizona, Seton Hall Law School, and the University of
                    Southern California, where he is also completing his D.Sc. in Regulatory Science.
                </span>
        },
        {
            name: "Mo Jain",
            field: "",
            company: "",
            degrees: [
            ],
            portrait: MoJain,
            bio: <span>
                    Dr. Jain is a physician-scientist with more than 20 years of expertise in physiology,
                    computational biology, and mass spectrometry-based bioanalytics. He formed the
                    Jain Laboratory at UCSD, where he led his team to develop next-generation mass
                    spectrometry systems to probe the non-genetic landscape of disease across
                    large-scale human studies. Dr. Jain founded Sapient in 2021 as a spinout
                    of the Jain Laboratory to expand upon this mission, providing bespoke
                    services multi-omics biomarker discovery.
                    <br/><br/>
                    Dr. Jain obtained his MD and PhD from Boston University School of Medicine,
                    and subsequently performed clinical residency and fellowship training in
                    Internal Medicine, Cardiology, and Preventative Cardiology at Brigham and
                    Women’s Hospital, Harvard Medical School. His postdoctoral work was performed
                    at the Broad Institute and Massachusetts General Hospital in the HHMI laboratory.
                </span>
        },
        {
            name: "Derrick Miyao",
            field: "",
            company: "",
            degrees: [
            ],
            portrait: DerrickMiyao,
            bio: <span>
                    Derrick Miyao is a leader in automated chemistry and AI-driven drug discovery,
                    with over 20 years of experience bridging science, technology, and innovation.
                    He spent two decades at Neurocrine Biosciences, where he built and led automated
                    chemistry programs that accelerated small molecule discovery.
                   <br/><br/>
                    As Vice President of the Molecular Foundry at Deepcure AI, Derrick oversaw the
                    development of a fully automated synthesis platform, integrating robotics,
                    purification, and multistep chemistry to advance scalable drug design.
                    He also chairs the Automated Synthesis Group for the Society for Laboratory
                    Automation and Screening (SLAS), helping to shape global discussions on the
                    future of chemistry automation. Derrick is currently working on his next venture
                    to synthesize molecules in San Diego with faster turnaround times and more
                    complexity versus traditional offerings.
                </span>
        },
        {
            name: "Yongdong Wang",
            field: "",
            company: "",
            degrees: [
            ],
            portrait: YongDongWang,
            bio: <span>
                    Yongdong Wang received his Ph.D. from the University of Washington in Seattle, WA
                    (USA) in chemometrics and process analytical chemistry. Yongdong’s interest has been
                    in the computational and statistical methods and their applications to analytical
                    chemistry problems. <br/><br/>His 10-year sting at Perkin Elmer Research in Norwalk, CT (USA),
                    first as a researcher and eventually as the Head of World Wide Science & Technology
                    Group resulted in over a dozen patents in scientific instrumentation, life science and the
                    application of statistical and mathematical processing to analytical problems. With an
                    Executive MBA from Columbia Business School, he started Cerno Bioscience to
                    provide innovative software solutions to MS users.
                </span>
        }
    ]

    return (
        <React.Fragment>

            <div className={"default-margin-top-xlarge default-display-flex"}>
                <div
                    className={"speaker-flex"}
                >
                {
                    speakers.map((speaker, idx) => {
                        return <Speaker
                                    key={"speaker_"+idx}
                                    name={speaker.name}
                                    company={speaker.company}
                                    degrees={speaker.degrees}
                                    field={speaker.field}
                                    bio={speaker.bio}
                                    portrait={speaker.portrait}
                                />
                    })
                }
                </div>
            </div>

        </React.Fragment>
    )

}